<template>
  <div class="footer">
    <subscription-block v-if="showSubscription && !LOGGED_IN" />
    <main-block />
    <copyright-block />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

/* Components */
import MainBlock from './main-block';
import CopyrightBlock from './copyright-block';
import SubscriptionBlock from './subscription-block';

export default {
  name: 'Footer',
  components: {
    SubscriptionBlock,
    CopyrightBlock,
    MainBlock,
  },
  props: {
    location: {
      type: String,
      default: 'footer_menu',
    }
  },
  computed: {
    ...mapGetters({
      MENU: 'menu/mainMenu',
      LOGGED_IN: 'user/loggedIn',
    }),

    showSubscription() {
      return ![
        '/account',
        '/stores',
        '/checkout',
      ].some(p => this.$router.currentRoute.fullPath.includes(p));
    },
  },
  methods: {
    ...mapActions({
      LOAD_MENU: 'menu/loadFooterMenu',
    }),
  },
  serverPrefetch() {
    return this.LOAD_MENU(this.location);
  }
};
</script>

<style lang="scss">
.footer {
  padding-bottom: env(safe-area-inset-bottom, 0);
  box-shadow: inset 0 1px 0 $gray_lu;
}
</style>
